import pages from "../Pages.json";
import IQACDynamicPage from '../DynamicPage/IQACDynamicPage';
import TableComponent from '../../components/Table/TableComponent';
import "./StaffAssociation.scss";

const StaffAssociation = () => {

    const staffAssociation = pages['staff-association'][0];
    const columns = ["S.No", "Name", "Designation & Department", "Members", "Email ID"];
    const rows = [
        { name: "Dr. R. Marimuthu", designation: "Principal", membership: "Chairman", email: "nicollege2001@yahoo.co.in" },
        { name: "Mr. R. P. Anil Kumar", designation: "Librarian", membership: "Convener", email: "2009anilkumar.lib@nicollege.com" },
        { name: "Mr. S. Sunil Kumar", designation: "Accountant", membership: "Treasurer", email: "sunilkumartpu7@gmail.com" },
    ];

    return (
        <section className="staffAssociationMainContainer">
            <article className="firstSection">
                <IQACDynamicPage
                    title={staffAssociation.title}
                    content={staffAssociation.content}
                    secondtitle={staffAssociation.secondtitle}
                />

                <article className='points-style'>
                    <ol className='points-ul-list'>
                        <li>Acts as a collective voice for staff, addressing concerns and negotiating with management on issues like working conditions, benefits, and policies.</li>
                        <li>Organizes workshops, seminars, and training sessions to enhance the skills and knowledge of staff members. </li>
                        <li>Promotes staff welfare by addressing grievances and ensuring fair treatment.</li>
                        <li>Arranges events, celebrations, and outings to foster team spirit and camaraderie. </li>
                        <li>Facilitates transparent communication between staff and management.</li>
                    </ol>
                </article>

            </article>

            <article className="secondSection">
                <h2 style={{ color: "#116C4A" }}>Staff Association - NICAS</h2>
                <TableComponent
                    columns={columns}
                    data={rows} />
            </article>
        </section>
    )
}

export default StaffAssociation
